import "./index.css";
import { useRoutes } from "react-router-dom";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { LoginPage } from "./pages/LoginPage";
import { getRoutes } from "./routes/routes";

const routes = getRoutes();

export function App() {
  const renderRoutes = useRoutes(routes);
  return (
    <>
      <UnauthenticatedTemplate>
        <LoginPage />
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>{renderRoutes}</AuthenticatedTemplate>
    </>
  );
}
